// The pictures an allergen can name (Q75). The API sends a key, never a picture, and the platform picks from these:
// Daghfal.Domain.Allergens.AllergenIcons is the same list, and AllergenCatalogueTests holds the two to each other.
//
// Twenty-four are Microsoft's Fluent Emoji "Flat" drawings (MIT, see icons/LICENSE-fluentui-emoji.txt); the rest
// were drawn for Daghfal in the same style where Fluent has none or none that reads (sesame, the single nuts, the
// pulses, mustard, celery, lactose, a tablet, dust). `?no-inline` keeps each a file of its own, fetched once and
// cached, rather than a data URL in every app's bundle.
import additive from './icons/additive.svg?no-inline';
import almond from './icons/almond.svg?no-inline';
import banana from './icons/banana.svg?no-inline';
import beans from './icons/beans.svg?no-inline';
import bee from './icons/bee.svg?no-inline';
import capsule from './icons/capsule.svg?no-inline';
import cashew from './icons/cashew.svg?no-inline';
import celery from './icons/celery.svg?no-inline';
import chickpea from './icons/chickpea.svg?no-inline';
import chocolate from './icons/chocolate.svg?no-inline';
import citrus from './icons/citrus.svg?no-inline';
import corn from './icons/corn.svg?no-inline';
import dust from './icons/dust.svg?no-inline';
import egg from './icons/egg.svg?no-inline';
import fava from './icons/fava.svg?no-inline';
import fish from './icons/fish.svg?no-inline';
import flower from './icons/flower.svg?no-inline';
import glove from './icons/glove.svg?no-inline';
import hazelnut from './icons/hazelnut.svg?no-inline';
import kiwi from './icons/kiwi.svg?no-inline';
import lactose from './icons/lactose.svg?no-inline';
import lentil from './icons/lentil.svg?no-inline';
import lupin from './icons/lupin.svg?no-inline';
import milk from './icons/milk.svg?no-inline';
import mustard from './icons/mustard.svg?no-inline';
import other from './icons/other.svg?no-inline';
import paw from './icons/paw.svg?no-inline';
import peanut from './icons/peanut.svg?no-inline';
import pistachio from './icons/pistachio.svg?no-inline';
import sesame from './icons/sesame.svg?no-inline';
import shrimp from './icons/shrimp.svg?no-inline';
import soy from './icons/soy.svg?no-inline';
import squid from './icons/squid.svg?no-inline';
import strawberry from './icons/strawberry.svg?no-inline';
import tablet from './icons/tablet.svg?no-inline';
import tomato from './icons/tomato.svg?no-inline';
import treeNuts from './icons/tree-nuts.svg?no-inline';
import walnut from './icons/walnut.svg?no-inline';
import wheat from './icons/wheat.svg?no-inline';

/** The picture for each icon key, in the order the platform console's grid shows them. */
export const ALLERGEN_ICONS: Readonly<Record<string, string>> = {
  'milk': milk,
  'lactose': lactose,
  'egg': egg,
  'peanut': peanut,
  'tree-nuts': treeNuts,
  'pistachio': pistachio,
  'cashew': cashew,
  'almond': almond,
  'walnut': walnut,
  'hazelnut': hazelnut,
  'sesame': sesame,
  'wheat': wheat,
  'fish': fish,
  'shrimp': shrimp,
  'squid': squid,
  'soy': soy,
  'chickpea': chickpea,
  'lentil': lentil,
  'lupin': lupin,
  'beans': beans,
  'fava': fava,
  'corn': corn,
  'strawberry': strawberry,
  'kiwi': kiwi,
  'banana': banana,
  'citrus': citrus,
  'tomato': tomato,
  'chocolate': chocolate,
  'additive': additive,
  'mustard': mustard,
  'celery': celery,
  'capsule': capsule,
  'tablet': tablet,
  'bee': bee,
  'glove': glove,
  'dust': dust,
  'flower': flower,
  'paw': paw,
  'other': other,
};

/** The generic picture: an allergy the catalogue does not know yet. */
export const OTHER_ALLERGEN_ICON = 'other';

/** The picture for a key, or the generic one for a key this build does not have (a newer API, say). */
export function allergenIconUrl(icon: string | null | undefined): string {
  return ALLERGEN_ICONS[icon ?? OTHER_ALLERGEN_ICON] ?? other;
}
